<template>
  <v-menu left offset-y min-width="100">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" icon>
        <v-icon color="#F99741" small>$export</v-icon>
      </v-btn>
    </template>

    <v-list class="py-4" dense>
<!--       <v-list-item @click="printTable()">
        <span class="font-size-style">Imprimir gráfico</span>
      </v-list-item> -->
     <!--  <v-list-item link @click="exportChart('image/png')">
        <v-list-item-content>
          <span class="font-size-style">Baixar imagem PNG</span>
        </v-list-item-content>
      </v-list-item> -->
 <!--      <v-list-item link @click="exportChart('image/jpeg')">
        <v-list-item-content>
          <span class="font-size-style">Baixar imagem JPEG</span>
        </v-list-item-content>
      </v-list-item> -->
<!--       <v-list-item link @click="exportChart('image/svg+xml')">
        <v-list-item-content>
          <span class="font-size-style">Baixar imagem SVG</span>
        </v-list-item-content>
      </v-list-item> -->
    <!--   <v-list-item link @click="exportPdf">
        <v-list-item-content>
          <span class="font-size-style">Baixar documento PDF</span>
        </v-list-item-content>
      </v-list-item> -->
     <!--  <v-list-item link @click="exportCSV">
        <v-list-item-content>
          <span class="font-size-style">Baixar documento CSV</span>
        </v-list-item-content>
      </v-list-item> -->
      <v-list-item link @click="exportXLS">
        <v-list-item-content>
          <span class="font-size-style">Baixar documento XLSX</span>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "MenuExportTable",
  props: {
    disableItems: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({}),
  methods: {
    exportXLS() {
      this.$emit("exportXLS");
    },

   
  },
};
</script>

<style>

.font-size-style {
  font-size: small;
}
</style>
